<template>
  <v-menu
    v-model="menu"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    min-width="auto"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        :value="value"
        :label="label"
        :error-messages="errorMessages"
        :clearable="clearable"
        prepend-icon="mdi-calendar"
        readonly
        v-bind="attrs"
        v-on="on"
        @click:clear="onClear"
      />
    </template>
    <v-date-picker
      :value="value"
      :min="min"
      no-title
      @input="onSelect"
    />
  </v-menu>
</template>

<script>
export default {
  name: "DateField",

  props: {
    value: {
      type: String,
      default: null
    },
    label: {
      type: String,
      default: "Date"
    },
    min: {
      type: String,
      default: undefined
    },
    clearable: {
      type: Boolean,
      default: false
    },
    errorMessages: {
      type: [String, Array],
      default: () => []
    }
  },

  data () {
    return {
      menu: false
    };
  },

  methods: {
    onSelect (date) {
      this.menu = false;
      this.$emit("input", date);
    },

    onClear () {
      this.$emit("input", null);
    }
  }
};
</script>
